import { View, Text, StyleSheet } from 'react-native';
import React, { useState, useEffect } from 'react';
import Toast from 'react-native-toast-message';

import Constants from '../constants';
import { Access, UserContext, WpUserAction } from '../contexts/user';
import CampaignOverview from '../components/CampaignOverview';
import LeadTable from '../components/Leads/LeadTable';
import Navbar from '../components/Navbar';
import { Button, Chart, DashboardNav, Input, PageTitle, PercentageCard, StatsCard } from '@ologyhealth/wp-components';
import { UsersIcon } from '@heroicons/react/outline';
import WpModal from '../components/WpModal';
import ModalBody from '../components/ModalBody';
import ModalFooter from '../components/ModalFooter';
import StripeCardElement from '../components/Shared/StripeCardElement';
import { useMutation, useQuery } from '@apollo/client';
import { INVITE_USERS, UPDATE_USER } from '../graphql/user';
import Icon from '../components/Icon';
import UserDetailsModal from '../components/User/UserDetailsModal';
import SuperAdminModal from '../components/User/SuperAdminModal';
import BillingModal from '../components/User/BillingModal';
import { Label } from '../components/Input';
import BasicLayout from '../components/Shared/BasicLayout';
import { GET_CAMPAIGNS } from '../graphql/queries';
import { useNavigate } from '../react-router';
import { GET_USER } from '../graphql/queries';

// const summaryData = [
//   {
//     "label": "Campaign 1",
//     "value": 70,
//     "tooltip": "Leads:1000"
//   },
//   {
//     "label": "Campaign 2",
//     "value": 40,
//     "tooltip": "Leads: 500"
//   },
//   {
//     "label": "Campaign 3",
//     "value": 30,
//     "tooltip": "Leads: 300"
//   },
//   {
//     "label": "Campaign 4",
//     "value": 45,
//     "tooltip": "Leads: 600"
//   },
//   {
//     "label": "Campaign 5",
//     "value": 60,
//     "tooltip": "Leads: 500"
//   }
// ]

interface SummaryData {
  label: string;
  value: number;
  tooltip: string;
}

export default function Dashboard(): JSX.Element {
  const { state, dispatch } = React.useContext(UserContext);
  const navigate = useNavigate();

  const [selectedLeads, setSelectedLeads] = useState<string[]>([]);
  const [summaryData, setSummaryData] = useState<SummaryData[]>([]);
  const [completePercentages, setCompletePercentages] = useState<number[]>([]);
  const [chartSelected, setChartSelected] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string | undefined>(undefined);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [isBillingModalVisible, setIsBillingModalVisible] = useState<boolean>(false);

  const campaignData = useQuery(GET_CAMPAIGNS, {
    fetchPolicy: "no-cache",
    variables: { includeFeatures: false, includeStats: true, recent: true }
  })

  const [updateUser, { loading: updateUserLoading }] = useMutation(UPDATE_USER, {
    fetchPolicy: "no-cache"
  });

  const { data: userData, refetch: refetchUser } = useQuery(GET_USER, {
    fetchPolicy: "network-only",
    variables: { includeBilling: true },
    skip: !state.user
  });

  // Check if billing is required and set up
  useEffect(() => {
    if (state.user && Constants.controls.requireBillingBeforeProceed) {
      const billingActive = state.user?.organization?.billing?.active;
      const hasCard = state.user?.organization?.billing?.card;
      
      console.log('Billing check:', {
        requireBillingBeforeProceed: Constants.controls.requireBillingBeforeProceed,
        billingActive,
        hasCard,
        billing: state.user?.organization?.billing
      });
      
      // Show modal if billing is required but not active OR no card exists
      if (!billingActive || !hasCard) {
        console.log('Showing billing modal - billing not active or no card');
        setIsBillingModalVisible(true);
      } else {
        console.log('Hiding billing modal - billing is active and card exists');
        setIsBillingModalVisible(false);
      }
    } else {
      setIsBillingModalVisible(false);
    }
  }, [state.user, state.user?.organization?.billing]);

  // Update user context when user data is refetched
  useEffect(() => {
    if (userData?.user?.success && userData?.user?.user) {
      dispatch({ type: WpUserAction.REFRESH_USER, user: userData.user.user });
    }
  }, [userData]);

  // Refetch user data when component mounts to ensure we have latest billing info
  useEffect(() => {
    if (state.user && Constants.controls.requireBillingBeforeProceed) {
      refetchUser();
    }
  }, []);


  console.log('selectedLeads', selectedLeads)

  useEffect(() => {
    if (campaignData.data?.campaigns?.campaigns) {
      let totalLeads = 0;
      let cps: number[] = [];
      let totalComplete = 0;

      let totalData: SummaryData[] = [];
      for (let i = 0; i < campaignData.data?.campaigns?.campaigns.length; i++) {
        let c = campaignData.data?.campaigns?.campaigns[i];

        let opened = '0';
        if (c.stats.leads > 0 && c.stats.opened > 0) {
          opened = (c.stats.opened / c.stats.leads * 100).toFixed(0);
        }

        let tooltip = "Leads: " + c.stats.leads + ", Opened: " + c.stats.opened + ", Completed: " + c.stats.complete;
        totalData.push({
          label: c.name ? c.name.substr(0, 12) + (c.name.length > 12 ? '...' : '') : '',
          value: parseInt(opened),
          tooltip: tooltip
        })

        totalLeads += c.stats.leads
        totalComplete += c.stats.complete

        let comp: string = '0';
        if (c.stats.leads > 0 && c.stats.complete > 0) {
          comp = (c.stats.complete / c.stats.leads * 100).toFixed(0);
        }
        cps.push(parseInt(comp))
      }

      let complete = '0';
      if (totalLeads > 0 && totalComplete > 0) {
        complete = (totalComplete / totalLeads * 100).toFixed(0);
      }
      cps.push(parseInt(complete))

      setSummaryData(totalData);
      setCompletePercentages(cps)
    }
  }, [campaignData.data])


  console.log('campaignData.data', campaignData.data)

  useEffect(() => {
    console.log('View Rate', state.user?.organization?.stats?.viewRate)
    console.log('Slide View Rate', state.user?.organization?.stats?.slideViewRate)
  }, [state.user])

  const handleSort = (column: string) => {
    if (sortBy === column) {
      // Toggle direction if clicking the same column
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Set new column and default to ascending
      setSortBy(column);
      setSortDirection('asc');
    }
  }

  const renderHeader = (): JSX.Element => {
    const getSortIndicator = (column: string) => {
      if (sortBy === column) {
        return sortDirection === 'asc' ? ' ↑' : ' ↓';
      }
      return '';
    }

    return (
      <View style={{ flexDirection: 'row', marginVertical: 20 }}>
        <Text 
          style={{ width: 200, marginLeft: 50, fontFamily: 'GothamMedium', color: Constants.colors.info, cursor: 'pointer' } as any}
          onPress={() => handleSort('name')}
        >
          Name{getSortIndicator('name')}
        </Text>
        <Text style={{ width: 200, fontFamily: 'GothamMedium', color: Constants.colors.info }}>Phone</Text>
        <Text 
          style={{ width: 200, fontFamily: 'GothamMedium', color: Constants.colors.info, cursor: 'pointer' } as any}
          onPress={() => handleSort('appointment')}
        >
          Appointment{getSortIndicator('appointment')}
        </Text>
        {Constants.blastView ? null : <Text style={{ width: 150, fontFamily: 'GothamMedium', color: Constants.colors.info }}>View Time</Text>}
        {Constants.blastView ? null : <Text style={{ width: 100, fontFamily: 'GothamMedium', color: Constants.colors.info }}>Views</Text>}
        <Text style={{ width: 150, fontFamily: 'GothamMedium', color: Constants.colors.info }}>{Constants.blastView ? 'Blasts' : 'Campaigns'}</Text>
      </View>
    )
  }

  const onSelectChart = (index: number, data: SummaryData) => {
    setChartSelected(index);
  }

  const getHeadingText = () => {
    if (Constants.oppText) {
      return 'Welcome to Ology Health';
    }

    return `Welcome${state.user?.firstName ? ` ${state.user.firstName}` : ''}`;
  }

  const handleBillingComplete = async (token?: string, plan?: string) => {
    if (state.user) {
      try {
        await updateUser({
          variables: {
            userId: state.user.id,
            user: {
              token: token,
              plan: plan
            }
          }
        });
        // Refetch user data to get updated billing info
        await refetchUser();
        setIsBillingModalVisible(false);
        Toast.show({
          type: 'success',
          text1: 'Billing information saved',
          text2: 'You can now access all features.'
        });
      } catch (error) {
        Toast.show({
          type: 'error',
          text1: 'Error',
          text2: 'Failed to save billing information. Please try again.'
        });
      }
    }
  }

  const handleBillingModalClose = () => {
    // Don't allow closing if billing is required but not set up
    if (Constants.controls.requireBillingBeforeProceed) {
      const billingActive = state.user?.organization?.billing?.active;
      const hasCard = state.user?.organization?.billing?.card;
      if (!billingActive || !hasCard) {
        return;
      }
    }
    setIsBillingModalVisible(false);
  }


  const renderBody = () => {
    if (state.user) {


      console.log('the state', state.user)

      console.log('summaryData', summaryData)

      if (Constants.blastView || Constants.oppText || Constants.tattooCare) {
        return (
          <View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text style={styles.heading}>{getHeadingText()}</Text>
            </View>
            <View style={{ flexDirection: 'row', gap: 20, marginVertical: 30, flexWrap: 'wrap' }}>
              <View style={{ flexGrow: 2, flexBasis: 'auto', minWidth: 250, flexDirection: 'column', justifyContent: 'flex-start', gap: 20 }}>
                <StatsCard
                  style={{ flex: 1 }}
                  description={'' + (state.user.stats.messages)}
                  title={"Messages Sent"}
                  type="White"
                >
                  <Icon style={{ padding: 15 }} name="message" color={Constants.colors.darkBlue} raw={true} />
                </StatsCard>




                <StatsCard
                  style={{ flex: 1 }}
                  description={'' + state.user.stats.leads}
                  title={Constants.localizations.Leads}
                  type="White"
                >
                  <Icon style={{ padding: 12 }} name="users" color={Constants.colors.darkBlue} raw={true} />
                </StatsCard>
              </View>
              <PercentageCard key="pc-delivery" style={{ flexGrow: 1, flexBasis: 'auto', minWidth: 250 }} title={"Delivery Rate"} percentage={state.user?.organization?.stats?.deliveryRate ? parseFloat((state.user.organization.stats.deliveryRate * 100).toFixed(1)) : 0} />
              {
                Constants.oppText || Constants.tattooCare ?
                  <PercentageCard key="pc-open" style={{ flexGrow: 1, flexBasis: 'auto', minWidth: 250 }} title={"Open Rate"} percentage={state.user?.organization?.stats?.openRate ? parseFloat((state.user.organization.stats.openRate * 100).toFixed(1)) : 0} /> :
                  <PercentageCard key="pc-response" style={{ flexGrow: 1, flexBasis: 'auto', minWidth: 250 }} title={"Response Rate"} percentage={state.user?.organization?.stats?.responseRate ? parseFloat((state.user.organization.stats.responseRate * 100).toFixed(1)) : 0} />
              }
            </View>
            <LeadTable header={renderHeader()} masked={!!(Constants.oppText && state.user.wpAdmin && state.user.organization.id !== "1")} selectable={true} searchable={true} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} sortBy={sortBy} sortDirection={sortDirection} />
          </View>
        )
      } else {
        return (
          <View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text style={styles.heading}>{getHeadingText()}</Text>
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 20, marginTop: 30, flexWrap: 'wrap' }}>
              <StatsCard
                style={{ flex: 1, maxWidth: 400, minWidth: 250 }}
                description={'' + (state.user.stats.messages)}
                title={"Messages Sent"}
                type="White"
              >
                <Icon style={{ padding: 15 }} name="message" color={Constants.colors.darkBlue} raw={true} />
              </StatsCard>
              <StatsCard
                style={{ flex: 1, maxWidth: 400, minWidth: 250 }}
                description={'' + state.user.stats.leads}
                title={Constants.localizations.Leads}
                type="White"
              >
                <Icon style={{ padding: 12 }} name="users" color={Constants.colors.darkBlue} raw={true} />
              </StatsCard>
              <StatsCard
                style={{ flex: 1, maxWidth: 400, minWidth: 250 }}
                description={'' + state.user.stats.views}
                title="Views"
                type="White"
              >
                <Icon style={{ padding: 12 }} name="eye" color={Constants.colors.darkBlue} raw={true} />
              </StatsCard>
            </View>
            {summaryData && summaryData.length > 0 ?
              <View style={{ flexDirection: 'row', gap: 20, marginTop: 20, marginBottom: 40, flexWrap: 'wrap' }}>
                <View style={{ flex: 3, minWidth: 350, borderRadius: 10, paddingRight: 20, backgroundColor: '#FFFFFF' }}>
                  <Chart legend={'Lead Open Rate'} defaultSelected={chartSelected} data={summaryData} type="Percentage" onSelect={onSelectChart} />
                </View>
                <PercentageCard style={{ flex: 1 }} title={Constants.blastView ? "Viewed" : "Completed"} percentage={completePercentages.length ? completePercentages[chartSelected] : 0} />
              </View> : <View style={{ marginVertical: 20 }}></View>}

            {state.user.organization.access === Access.LIMITED ? null : <LeadTable header={renderHeader()} selectable={!Constants.blastView || state.user?.wpAdmin || state.user?.id === "15"} searchable={true} selectedLeads={selectedLeads} setSelectedLeads={setSelectedLeads} sortBy={sortBy} sortDirection={sortDirection} />}
          </View>
        )
      }
    } else {
      return (
        <View>
        </View>
      )
    }
  }

  // Show billing modal overlay if billing is required but not set up
  const billingActive = state.user?.organization?.billing?.active;
  const hasCard = state.user?.organization?.billing?.card;
  const shouldShowBillingModal = Constants.controls.requireBillingBeforeProceed && 
    state.user && 
    (!billingActive || !hasCard);

  return (
    <BasicLayout style={styles.container} active={'/dashboard'}>
      <View style={{ position: 'relative' }}>
        {shouldShowBillingModal && (
          <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999 }} />
        )}
        {renderBody()}
      </View>
      <BillingModal 
        isVisible={isBillingModalVisible} 
        onClose={handleBillingModalClose} 
        loading={updateUserLoading} 
        onComplete={handleBillingComplete}
        card={state.user?.organization?.billing?.card}
        title="Complete Your Billing Information"
        newUser={true}
      />
    </BasicLayout>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 25,
    backgroundColor: Constants.colors.backgroundLight
  },
  heading: {
    fontSize: 30,
    color: Constants.colors.blue,
    fontFamily: 'GothamBold',
    marginRight: 10
  },
  headingLink: {
    fontSize: 16,
    fontFamily: 'GothamBold',
    color: Constants.colors.darkBlue,
    textDecorationLine: 'underline'
  },
})

const cssStyles = {
  icon: {
    width: 30,
    height: 30,
    color: Constants.colors.info
  },
  stat: {
    width: 40,
    height: 40,
    color: Constants.colors.blue
  },
  input: {
    boxSizing: 'border-box',
    marginBottom: 20,
    border: '1px solid ' + Constants.colors.info + '44',
    padding: 5,
    width: '100%',
    height: 40,
    borderRadius: 7,
    flex: 1
  }
}
